import { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import Logo3D from '../Logo3D';
import Button from '../Fpb/leftMenu/Button';

const LoadingHolder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  color: white;
`;

const PasswordRowHolder = styled.div`
  display: flex;
  gap: 10px;
`;

const PasswordInput = styled.input`
  font-family: sans-serif;
  font-size: 20px;
  color: rgba(255, 255, 255, 0.75);

  border: 0;
  width: 200px;
  background-color: rgba(255, 255, 255, 0.25);
  border-radius: 4px;
  padding: 0 4px;
`;

const SubmitButton = styled(Button)`
  flex-grow: 0;
  width: 80px;
`;

const PasswordForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  padding: 26px 10px 10px 10px;
  width: 300px;
  max-width: 100vw;
  background-color: #4448;
  backdrop-filter: blur(20px);
  border-radius: 8px;
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.12);
  gap: 10px;
`;

const Error = styled.div`
  color: #ff6b6b;
  font-size: 14px;
`;

// Hash function using built-in Web Crypto API
const hashPassword = async (password) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(password);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
};

// Password configuration - read hashed passwords from environment variables
// To generate a hash: console.log(await hashPassword("your-password-here"))
const SECURE_PASSWORD_HASHES = JSON.parse(process.env.REACT_APP_SECURE_ROUTE_PASSWORD_HASHES || '{}');

const PasswordProtection = ({ children, secureDatasetName }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = useCallback(async () => {
    try {
      const passwordHash = await hashPassword(password);
      if (passwordHash === SECURE_PASSWORD_HASHES[secureDatasetName]) {
        setIsAuthenticated(true);
        setError('');
      } else {
        setError('Invalid password');
      }
    } catch (err) {
      setError('Authentication error');
    }
  }, [password, secureDatasetName]);

  // When user presses enter in the password input, submit the form
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
        handleSubmit();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleSubmit]);

  if (!isAuthenticated) {
    return (
      <LoadingHolder>
        <Logo3D />
        <PasswordForm>
          <span>Enter password:</span>
          <PasswordRowHolder>
            <PasswordInput placeholder="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
            <SubmitButton onClick={handleSubmit}>Submit</SubmitButton>
          </PasswordRowHolder>
          <Error>{error ? error : <>&nbsp;</>}</Error>
        </PasswordForm>
      </LoadingHolder>
    )
  }

  return children;
};

export default PasswordProtection; 